<!-- 组件说明 -->
<template>
  <div>
    <van-sticky>
     <van-nav-bar
      title="商品評價"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
      />
    </van-sticky>
    
     <div style="display:flex">
        <van-image-preview v-model="show" :images="images" @change="onChange">
          <template v-slot:index>第{{ index+1 }}张</template>
        </van-image-preview>
       </div>
      <!-- <van-row type="flex" justify="space-between" class="commentTitle" style="">
        <van-col span="8"><span>商品評價 共({{commentNums || 0}})則評論</span></van-col>
        <van-col span="5"><span>查看全部 ></span></van-col>
      </van-row> -->
        <van-row style="text-align:center;">
            <van-col span="8"  style="padding:8px" v-for="(item,i) in commentList" :key="i" >
                <div class="commentName"  :class="{activesss: item.isActive}" @click="getComment(i,item.num)"><p>{{item.lable}}</p><span>({{item.num}})</span></div>
            </van-col>
        </van-row>
        <van-row  type="flex" justify="space-between" style="text-align:center; border-bottom: 1px solid #ccc;padding: 0 10px 20px 10px; margin-bottom: 20px;">
            <van-col span="4"    v-for="(item,i) in getCommentList" :key="i" >
                <div class="commentNames" :class="{activesss: item.isActive}" @click="getCommentRate(i,item.num,item.nums)"><van-rate v-model="item.num" :size='5'  readonly /><p>({{item.nums}})</p></div>
            </van-col>
        </van-row>
        <van-row style="margin:10px 0px;overflow:auto;height: 70vh;"  class="infinite-list-wrapper"  v-infinite-scroll="load"
          infinite-scroll-disabled="disabled">
          <div v-for="(item,index) in prodCommList" :key="index" class="prod-comm" >
            <van-card 
              :desc='item.recTime'
              :title="item.userName"
              :thumb="item.userPortrait == null ? '../../../static/123.jpg' : item.userPortrait"
            >
            </van-card>
          <div style="padding: 0px 0 0 10px;">
            <div class="margin_10">{{item.content}}</div>
            <span v-for="(itemss,i) in item.tags.split(',')"  :key="i" style="margim:6px 0 0 0 ">
              <span style="padding: 5px;background-color: rgba(0,0,0,.04); border-radius: 5px;margin: 0 3px;" v-if="itemss">{{itemss}}</span>
            </span>
              <div  class="img-flex">
                <p  v-if="!item.pics" ></p>
                <van-image v-else-if="item.pics.indexOf(',')!=-1" width="100"  height="100" v-for="(items,indexs) in item.pics.split(',')" :key="indexs" :src='items' @click="getimgList(item.pics,indexs)" />
                <van-image  v-else width="100" height="100" :src='item.pics' @click="getimgList(item.pics,0)" />
              </div>
              <!-- <div class="margin_10" v-for="(list,i) in prodCommentList" :key="i">
                <van-row>
                    <van-col span="4">
                        <img :src="list.pic">
                    </van-col>
                    <van-col span="20" class="prodName" >
                        <p >{{list.prodName}}</p>
                        <span>{{list.prodNorms}}</span>
                    </van-col>
                </van-row>
                <div class="margin_10 businessReply">
                  <p>{{list.businessName}}</p>
                  <span>{{list.businessReply}}</span>
              </div>
              </div> -->
              
            </div>
          </div>
            <div style="text-align:center">
              <p v-if="loading">加载中...</p>
              <p v-if="noMore">没有更多了</p>
            </div>
        </van-row>
  </div>
 
</template>

<script>
import goods from "@/api/goods";
import { Toast, Image ,NavBar,ImagePreview,Col, Row ,Rate  } from 'vant';
export default {
  components: {},
  name:'comment',
  data() {
    return {
        total:'',
        count: 1,
        loading: false,
        show:false,
        images:[],
        list:[],
        commentNums:null,
        prodCommList:[],
        prodId:'',
        commentList:[
            {
                lable: '全部',
                num:'1212',
                isActive: true,
            },
            {
                lable: '附上評論',
                num:'1212',
                isActive: false,
            },
            {
                lable: '附上照片/影片',
                num:'1212',
                isActive: false,
            }
        ],
        getCommentList:[
            {
                num:5,
                isActive: false,
                nums:'',
            },{
                num:4,
                nums:'',
                isActive: false,
            },{
                num:3,
                nums:'',
                isActive: false,
            },{
                num:2,
                nums:'',
                isActive: false,
            },{
                num:1,
                nums:'',
                isActive: false,
            }
        ],
        prodCommentList:[
            {
                pic:'https://s-cf-tw.shopeesz.com/file/2958a7592a2a9cb3d97e864177289d18_tn',
                prodName:'山葉 YAMAHA 原廠齒輪油 G-110.GII-110.G-130.GII-130.GII-200 勁戰.force',
                prodNorms:'Variation: GII-130  藍罐 10W-30',
                businessName:"Seller's Response",
                businessReply:'感謝您的購買，若有需要歡迎隨時回購，期待下次為您服務🙏🙏'
            }
        ]
    }
  },
  created(){
      let param = this.$route.params
      this.prodId = param.id
      let parmas = {
          // comm:i,
          current:1,
          prodId:this.prodId,
          score:'',
          size:10
        }
      this.getDateList(parmas)
      this.getComment(0,this.commentList[0].num)
      
  },
  computed: {
      noMore () {
        // console.log('Math.ceil(this.total)',Math.ceil(this.total))
        return this.count >= Math.ceil(this.total/10);
        
      },
      disabled () {
        return this.loading || this.noMore
      }
    },
  methods:{
    load () {
        this.loading = true
        setTimeout(() => {
          this.count += 1
          console.log('this.count',this.count)
          let parmas = {
            // comm:i,
            current:this.count,
            prodId:this.prodId,
            score:'',
            size:10
          }
          this.getDateList(parmas)
          this.loading = false
        }, 2000)
      },
      getComment(i,num){
        this.count = 1
        this.total = num
        // console.log('this.total',this.total)
        this.prodCommList = []
          this.commentList.forEach((item,index)=>{
              item.isActive = false
          })
          this.commentList[i].isActive =true
          this.getCommentList.forEach((item,index)=>{
              item.isActive = false
          })
          
          if(i == 0){
            let parmas = {
            comm:i,
            current:1,
            prodId:this.prodId,
            score:'',
            size:10
          }
            this.getDateList(parmas)
          }else if(i == 1){
            let parmas = {
            comm:0,
            current:1,
            prodId:this.prodId,
            score:'',
            size:10
          }
            this.getDateList(parmas)
          }else{
            let parmas = {
            comm:1,
            current:1,
            prodId:this.prodId,
            score:'',
            size:10
          }
             this.getDateList(parmas)
          }
      },
      getCommentRate(i,num,nums){
        this.count = 1
        this.total = nums
        this.prodCommList = []
          this.getCommentList.forEach((item,index)=>{
              item.isActive = false
          })
          this.getCommentList[i].isActive =true
          this.commentList.forEach((item,index)=>{
              item.isActive = false
          })
          let parmas = {
            current:1,
            prodId:this.prodId,
            score:num,
            size:10
          }
        this.getDateList(parmas)
      },
      getDateList(evaluate){
        goods.getProdComm(evaluate).then((data) => {
            this.commentList[0].num =  data.total
            this.commentList[1].num = data.commCount
            this.commentList[2].num = data.picCount
            this.getCommentList[4].nums = data.count1
            this.getCommentList[3].nums = data.count2
            this.getCommentList[2].nums = data.count3
            this.getCommentList[1].nums = data.count4
            this.getCommentList[0].nums = data.count5
            // this.total = data.total
            this.prodCommList = data.prodCommIPage.records.concat(this.prodCommList)
        });
      },
      onClickLeft(){
          this.$router.back()
      },
      onChange(){

      },
      // 评论放大图片
    getimgList(pic,item){
      let List = []
      if(pic.indexOf(',')!=-1){
        List = pic.split(',')
        // this.images = List
      }else{
        if(pic){
          List.push(pic)
          this.images = List
        }else{
          //  this.show = false
        }
      }
        ImagePreview({
        images: List,
      startPosition: item,
    });
      // // debugger
      
    },
  }
}
</script>

<style lang='scss' scoped='scoped'>
.commentTitle{
  text-align:center;
  padding: 15px 0px;
  border-bottom: 0.5px solid #f3eeee;
}
.commentTitle div:nth-child(2) span{
  color: #ee4d2d;
}
.van-image-preview__image{
  display: flex;
}
.prod-comm {
  overflow: hidden;
  padding-bottom: 20px;
  border-bottom: 1px solid #f3eeee;
}
.prod-comm .van-card__thumb {
  width: 35px;
  height: 35px;
  margin-top: -2px;
}
.prod-comm .van-card {
  height: 50px;
  background: #fff;
}
.img-flex {
  margin: 10px;
  display: flex;
  flex-wrap: wrap;
//   margin-bottom: 20px;
//   padding-bottom: 20px;
}
.van-image__error, .van-image__img, .van-image__loading{
    height: auto;
}
.commentName{
    background:#F4F4F4;
    border-radius:5px;
    padding:8px;
    border:1px solid transparent
}
.commentNames{
    background:#F4F4F4;
    border-radius:5px;
    padding:10px;
    border:1px solid transparent
}
.commentName span{
    color:#9a9a9a;
}
.activesss{
    border:1px solid #ee4d2d;
    color:#ee4d2d ;
    background:white;
}
.activesss span{
    color:#ee4d2d ;
}
.margin_10{
    margin:10px
}
.businessReply{
    padding: 10px;
    background-color: rgba(0,0,0,.04);
}
.businessReply p{
    color: #8b572a;
}
.van-card__thumb{
    width: 25px!important;
}
.prodName{
    padding:8px;
    height:54px;
    background:#F4F4F4
}
.prodName p{
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap;
}
</style>


// WEBPACK FOOTER //
// src/pages/comment/comment.vue